import React from 'react'
import PropTypes from 'prop-types'
import { GGRadio } from '../../../../shared/new_components/GGRadio'
import { makeT } from '../../../../group_leader/helpers/i18n'

// How to distribute handicaps within a group, for the AB and ABCD algorithms.

const t = makeT('group_leader.event_setup.pairings')

const OPTIONS = [ [ '3', 'balance_hi' ], [ '4', 'place_low_to_high' ], [ '5', 'random' ] ]

const OptimizationOptions = ({ value, onChange, showBalance }) => (
  <div className="gl-event-setup-rg-sub">
    {OPTIONS.filter(([ option ]) => showBalance || option !== '3').map(([ option, key ]) => (
      <GGRadio
        key={option}
        className="gl-event-setup-rg-sub-opt"
        name="rg-opt"
        value={option}
        selected={value}
        onChange={onChange}
        label={t(`reorganize.${key}`)}
      />
    ))}
  </div>
)

OptimizationOptions.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  // Balancing handicap indexes only applies up to a foursome
  showBalance: PropTypes.bool,
}

export default OptimizationOptions
